var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"order-error"}},[_c('div',{class:_vm.getClassBody},[_c('h4',{class:_vm.getStyle},[_vm._v(_vm._s(_vm.error))]),_vm._v(" "),_c('p',[_vm._v("\n      "+_vm._s(_vm.descr)+"\n    ")]),_vm._v(" "),_c('div',[(_vm.getButtonMessage)?_c('button',{staticClass:"btn btn-success",on:{"click":_vm.onButtonClicked}},[_vm._v("\n        "+_vm._s(_vm.getButtonMessage)+"\n      ")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28f49a51","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/OrderError.vue
// module id = 426
// module chunks = 0